import { render } from "./InputLabel.vue?vue&type=template&id=29151a53&lang=pug"
import script from "./InputLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./InputLabel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__